import React, { Component } from 'react'
import { SCREEN_SIZES } from 'aria-viewer/tour/constants'

class PhotoPrompt extends Component {
    render() {
        const { sizes, position, onMouseMove, onMouseDown, onMouseUp } = this.props
        const largeScreen = sizes && sizes.width >= SCREEN_SIZES.size_1350
        return (
            <div
                style={{
                    zIndex: 3,
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    pointerEvents: 'all',
                }}
                onMouseMove={onMouseMove}
                onMouseDown={onMouseDown}
                onMouseUp={onMouseUp}
            >
                <div
                    style={{
                        display: position ? 'block' : 'none',
                        position: 'absolute',
                        background: 'rgba(0, 0, 0, 0.7)',
                        color: 'white',
                        left: position ? position.left : 0,
                        top: position ? position.top : 0,
                        padding: largeScreen ? 10 : 7,
                        transform: 'translate(-50%, -50%)',
                        fontSize: largeScreen ? 20 : 15,
                        fontWeight: 400,
                        borderRadius: 6,
                        minWidth: largeScreen ? 130 : 110,
                        textAlign: 'center',
                        userSelect: 'none',
                    }}
                >
                    This is a photo
                </div>
            </div>
        )
    }
}

export default PhotoPrompt
